import styled from 'styled-components';

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 60px 100px;

    @media (max-width: 1200px) {
            padding: 100px 40px 100px;
    }

    @media (max-width: 800px) {
            padding: 100px 20px 100px;
    }
`;
